import { toMapCoordinate } from './toMapCoordinate'
import { OrderMapPoint } from '@/features/orders/components/MapPanel/parts/Content/types'
import { DeliveryTypeCategory, Phase, State } from '@/features/orders/constants/app'
import { Order } from '@/features/orders/types/app'

export const toOrderMapPoints = (orders: (Order | undefined)[]) => {
    const points: OrderMapPoint[] = []

    for (const order of orders) {
        if (
            !order ||
            order.deliveryType.typeCategory !== DeliveryTypeCategory.Delivery ||
            order.phase === Phase.Archived ||
            order.state === State.Cancelled ||
            order.deliveredAt
        ) {
            continue
        }

        const coordinate = toMapCoordinate(order.deliveryAddress?.coordinates)

        if (!coordinate) continue

        points.push({ id: order.id, coordinate, label: order.shortCode || '?', kind: 'order' })
    }

    return points
}
